import { useToast } from "common/hooks/useToast"
import { getErrorMessage } from "governance/helpers/error"
import type { MetamaskError } from "governance/types/metamask"

type Values = {
  withErrorCatch: (
    proposalAdminActionFunc: () => Promise<void>,
  ) => Promise<void>
}

export const useWithProposalErrorCatch = (): Values => {
  const { toast } = useToast()

  const withErrorCatch = async (
    proposalAdminActionFunc: () => Promise<void>,
  ): Promise<void> => {
    try {
      await proposalAdminActionFunc()
    } catch (error) {
      const parsedErrorMessage = getErrorMessage(error as MetamaskError)

      toast({
        status: "error",
        title: "Error",
        description: parsedErrorMessage as string,
      })
    }
  }

  return {
    withErrorCatch,
  }
}
